import React from "react";

const FaqLTOCert = () => {
  return (
    <>
      <div className="w-full">
        <input type="checkbox" name="panel" id="panel-10" className="hidden" />
        <label
          htmlFor="panel-10"
          className="relative block pb-2 px-1 pt-1 accordion-label text-base font-bold border-b-2"
        >
          <span className="inline-block w-11/12">
            What is the Certificate of Validation?
          </span>
        </label>
        <div className="accordion__content overflow-hidden bg-grey-lighter">
          <div className="accordion__body px-3 pt-2 pb-5" id="panel10">
            <p className="text-sm">
              The Certificate of Validation is an electronic confirmation
              generated through the DBP-DCI system that verifies:
            </p>
            <ul className="text-sm mt-3">
              <li>• The CTPL policy has been properly issued</li>
              <li>
                • The policy details are recorded in the national insurance
                validation system
              </li>
              <li>• The insurance can be used for LTO registration</li>
            </ul>
            <p className="text-sm mt-3">
              The certificate is sometimes referred to as the “DBP-DCI
              Certification Valid for Motor Vehicle Information.”
            </p>
          </div>
        </div>
      </div>

      <div className="w-full mt-2">
        <input type="checkbox" name="panel" id="panel-11" className="hidden" />
        <label
          htmlFor="panel-11"
          className="relative block pb-2 px-1 pt-1 accordion-label text-base font-bold border-b-2"
        >
          <span className="inline-block w-11/12">
            Why is CTPL validation required?
          </span>
        </label>
        <div className="accordion__content overflow-hidden bg-grey-lighter">
          <div className="accordion__body px-3 pt-2 pb-5" id="panel11">
            <p className="text-sm">
              The Land Transportation Office (LTO) issued Memorandum MVL 2026
              004, which requires that CTPL Certificates of Coverage (COC) used
              for vehicle registration must also be accompanied by a
              Certificate of Validation.
            </p>
            <p className="text-sm mt-3">
              This is a newly implemented process that is applied in addition to the
              existing authentication process conducted by ISAP COCAF and has
              not yet been implemented nationwide.
            </p>
            <p className="text-sm mt-3">
              The validation is generated through the DBP Data Center, Inc.
              (DBP DCI) system, which verifies that the insurance policy is
              active.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full mt-2">
        <input type="checkbox" name="panel" id="panel-12" className="hidden" />
        <label
          htmlFor="panel-12"
          className="relative block pb-2 px-1 pt-1 accordion-label text-base font-bold border-b-2"
        >
          <span className="inline-block w-11/12">
            What should I do after purchasing CTPL/COC?
          </span>
        </label>
        <div className="accordion__content overflow-hidden bg-grey-lighter">
          <div className="accordion__body px-3 pt-2 pb-5" id="panel12">
            <p className="text-sm">
              If you have purchased your CTPL policy but your LTO office did
              not accept your Certificate of Coverage (COC) and requires a
              Certificate of Validation, please follow these steps:
            </p>
            <ol className="text-sm mt-3 list-decimal list-inside">
              <li>
                Contact Standard Insurance via email at{" "}
                <span className="text-blue-500">ginsure@standard-insurance.com</span>{" "}
                or by mobile at 0917 828 3934.
              </li>
              <li>
                Ensure that the additional Php60 fee has been paid for the
                Certificate of Validation.
              </li>
              <li>
                Wait for the issuance of the certificate, which may take up to 24 hours to process.
              </li>
              <li>
                Once you receive the Certificate of Validation, proceed with your vehicle registration at the LTO.              </li>
            </ol>
          </div>
        </div>
      </div>

      <div className="w-full mt-2">
        <input type="checkbox" name="panel" id="panel-13" className="hidden" />
        <label
          htmlFor="panel-13"
          className="relative block pb-2 px-1 pt-1 accordion-label text-base font-bold border-b-2"
        >
          <span className="inline-block w-11/12">
            How long does the issuance of certificate of validation take?
          </span>
        </label>
        <div className="accordion__content overflow-hidden bg-grey-lighter">
          <div className="accordion__body px-3 pt-2 pb-5" id="panel13">
            <p className="text-sm">
              Validation may take up to 24 hours after the CTPL policy is
              purchased.
            </p>
            <p className="text-sm mt-3">
              During this time, the insurance policy information is submitted
              and verified through the validation system of DBP-DCI. Once
              validation is completed, the policy can be used for vehicle
              registration with the LTO.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full mt-2">
        <input type="checkbox" name="panel" id="panel-14" className="hidden" />
        <label
          htmlFor="panel-14"
          className="relative block pb-2 px-1 pt-1 accordion-label text-base font-bold border-b-2"
        >
          <span className="inline-block w-11/12">
            Is there a fee for the validation?
          </span>
        </label>
        <div className="accordion__content overflow-hidden bg-grey-lighter">
          <div className="accordion__body px-3 pt-2 pb-5" id="panel14">
            <p className="text-sm">
              Some LTO offices may require a Php60.00 validation fee for the
              Certificate of Validation.
            </p>
            <p className="text-sm mt-3">
              This fee is charged for generating the certificate through the
              DBP-DCI validation system.
            </p>
            <p className="text-sm mt-3">
              Please note that this fee may only apply in certain LTO regions
              or branches depending on their requirements.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqLTOCert;
